module.exports = __webpack_public_path__ + "img/film-threat-optimization-3.aa6950d3.svg";